// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"49c6b679","164":"dd1d5e60","367":"42bb2d56","787":"b2c3f5bb","834":"d654e807","886":"d99169fb","919":"31dbb1be"}[chunkId] + ".chunk.js";
};